import BaseService from "../base-service/BaseService";

const ControllerBase: string = "sizeguide";

export default class SizeGuideService {

    public static async GetSizeGuidesList(storeId: string) {
        let data: any = {};
    
        try {
    
          data = await BaseService.GetServices(ControllerBase, `${storeId}/list`);

        } catch (error) {
          console.log(error);
        }
    
        return data;
    }
}